import { render, staticRenderFns } from "./sbOrdineDiServizio.vue?vue&type=template&id=77bbfe57&"
import script from "./sbOrdineDiServizio.vue?vue&type=script&lang=js&"
export * from "./sbOrdineDiServizio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports